import { VIEW_CLICKUP_REQUEST,  VIEW_CLICKUP_REQUEST_ERROR,  VIEW_CLICKUP_REQUEST_SUCCESS } from "../actionType/type";

const initialState = {
    data: null,
    isLoading: false,
};

export const viewClickupReducers = (state=initialState,action) => {
    let object
    switch (action.type) {
        case  VIEW_CLICKUP_REQUEST:
            object = {
                ...state,
                isLoading: true,
              }
            break
        case  VIEW_CLICKUP_REQUEST_ERROR:
            object = {
                ...state,
                isLoading:false
            }
            break
        case  VIEW_CLICKUP_REQUEST_SUCCESS:
            object = {
                ...state,
                data:action.payload,
                isLoading:false
            }
            break
    
        default:
            object = state
            break
    }
    return object
}